import { Component, Input } from '@angular/core';
import { UiTableColumn, UiTableTemplates } from './ui-table.types';

@Component({
  selector: 'app-ui-table',
  templateUrl: './ui-table.component.html',
  styleUrls: ['./ui-table.component.css'],
  standalone: false,
})
export class UiTableComponent<T> {
  @Input() rows: T[] = [];
  @Input() columns: UiTableColumn<T>[] = [];
  @Input() mobileColumns?: UiTableColumn<T>[];
  @Input() templates: UiTableTemplates = {};
  @Input() rowTitle: (row: T) => string = () => '';
  @Input() trackBy: (index: number, row: T) => unknown = (index) => index;
  @Input() emptyText = 'No se encontraron registros.';
  @Input() tableClass = '';

  mobileExpanded = new Set<number>();
  @Input() expandAll = true;

  get visibleMobileColumns(): UiTableColumn<T>[] {
    return this.mobileColumns ?? this.columns.filter((column) => column.mobile !== false);
  }

  isMobileOpen(index: number): boolean {
    return this.expandAll && !this.mobileExpanded.has(index);
  }

  toggleMobileCard(index: number, event?: Event): void {
    event?.stopPropagation();
    if (this.mobileExpanded.has(index)) this.mobileExpanded.delete(index);
    else this.mobileExpanded.add(index);
  }

  toggleAllMobileCards(): void {
    this.expandAll = !this.expandAll;
    this.mobileExpanded.clear();
  }

  cellValue(row: T, column: UiTableColumn<T>): unknown {
    return column.value ? column.value(row) : (row as any)[column.key];
  }

  trackRow = (index: number, row: T): unknown => {
    return this.trackBy(index, row);
  };
}
